'use client'

// import { useState } from 'react'
import Button from '@/components/ui/Button'
import FormInput from '@/components/ui/Forms/FormInput'
// import { formatTime } from '@/utils/formatDate'
// import IncorrectOTP from './password-recovery/IncorrectOTP'
import { useOTPForm } from '@/hooks/forms/useOTPForm'
import { FieldValues } from 'react-hook-form'
// import Title from '@/components/ui/Title'

// const timeForNewCode: number = 120 // 2 mins
interface InvitationData {
  agencyId: string
  roleName: string
  companyName: string
  industry: string
  employees: string
}
interface IOTPFormProps {
  firstStepData: FieldValues
  type: 'passwordRecovery' | 'signup'
  isInvitedUser: boolean
  invitationData?: InvitationData
  onOTPVerified?: () => void
}

const OTPForm = ({ firstStepData, type, onOTPVerified, isInvitedUser }: IOTPFormProps) => {
  const {
    isLoading,
    errors,
    register,
    // reset,
    handleSubmit,
    onSubmitVerifySignUpOTP,
    resendSignupOTP,
    successMessage,
    watch
  } = useOTPForm()

  const otpValue = watch('otp')
  const isOTPValid = otpValue && otpValue.length === 6

  // const [timeLeft, setTimeLeft] = useState(timeForNewCode)
  // const [isCodeExpired, setIsCodeExpired] = useState(false)

  // useEffect(() => {
  //   if (timeLeft <= 0) {
  //     setIsCodeExpired(true)
  //     return
  //   }

  //   const intervalId = setInterval(() => {
  //     setTimeLeft(prev => prev - 1)
  //   }, 1000)

  //   return () => clearInterval(intervalId)
  // }, [timeLeft])

  const handleSendNewCode = () => {
    // setIsCodeExpired(false)
    // setTimeLeft(timeForNewCode)
    resendSignupOTP(firstStepData.email)
    // setTimeout(() => reset(), 0)
  }

  const submitOTP = (data: FieldValues) => {
    if (type === 'signup') {
      onSubmitVerifySignUpOTP(firstStepData.email, data.otp, isInvitedUser, firstStepData.password, onOTPVerified)
    }
  }

  return (
    <>
      {/* {!!errors.otp?.message &&
        errors.otp?.message.toString().includes('expired') && (
          <IncorrectOTP className='mt-5' />
        )} */}
      <form onSubmit={handleSubmit(submitOTP)}>
        <FormInput
          type='text'
          variant='primary'
          label='OTP Code'
          placeholder='Enter 6 digits'
          id='-form-otp'
          labelClassName='text-ui-black'
          {...register('otp')}
          // error={
          //   !errors.otp?.message?.toString().includes('expired')
          //     ? errors.otp?.message
          //     : ''
          // }
          error={errors.otp?.message}
          disabled={isLoading}
        />
        {/* <div className='mt-5 flex items-center text-sm'>
          <div className='text-ui-gray'>
            {isCodeExpired ? 'Code has expired' : 'Code expires in'}
          </div>
          &nbsp;
          <div>{!isCodeExpired && formatTime(timeLeft)}</div>
        </div> */}
        <Button
          // type={!isCodeExpired ? 'submit' : 'button'}
          type='submit'
          variant='orange'
          size='primary'
          className='mt-5 w-full'
          disabled={isLoading || !isOTPValid}
          // onClick={isCodeExpired ? handleSendNewCode : undefined}
        >
          {/* {isCodeExpired ? 'Send code again' : 'Submit'} */}
          Submit
        </Button>

        {successMessage && (
          <p className='mt-4 text-center text-green-600'>{successMessage}</p>
        )}

        <div className='mt-4 flex items-center justify-center gap-1 text-sm'>
          <span className='text-[#6B7280]'>Didn&apos;t get the code?</span>
          <button
            type='button'
            onClick={handleSendNewCode}
            className='decoration-skip-ink-none font-medium text-[#FE6434]'
          >
            Resend
          </button>
        </div>
      </form>
      {/* </div> */}
    </>
  )
}

export default OTPForm
